import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createProduct, restoreProduct, retireProduct, updateProduct } from '../services/products';
import type { ProductPayload } from '@/features/products/types/products.types';
import { productKeys } from '@/features/products/hooks/useProductsQuery';

export const useProductMutations = () => {
    const queryClient = useQueryClient();
    const invalidateLists = () =>
        queryClient.invalidateQueries({ queryKey: productKeys.lists() });

    return {
        createMutation: useMutation({
            mutationFn: createProduct,
            onSuccess: invalidateLists,
        }),
        updateMutation: useMutation({
            mutationFn: ({ id, payload }: { id: string; payload: ProductPayload }) =>
                updateProduct(id, payload),
            onSuccess: async (_data, vars) => {
                await invalidateLists();
                await queryClient.invalidateQueries({
                    queryKey: productKeys.detail(vars.id),
                });
            },
        }),
        retireMutation: useMutation({
            mutationFn: retireProduct,
            onSuccess: async (_data, id) => {
                await invalidateLists();
                await queryClient.invalidateQueries({ queryKey: productKeys.detail(id) });
            },
        }),
        restoreMutation: useMutation({
            mutationFn: restoreProduct,
            onSuccess: async (_data, id) => {
                await invalidateLists();
                await queryClient.invalidateQueries({ queryKey: productKeys.detail(id) });
            },
        }),
    };
};
